/* ============================================================
   Alatreyu Collection — JavaScript
   Horizontal carousel, filter chips, sort buttons,
   peek-card opacity, auto-fit long product names.
   ============================================================ */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initCarousel();
    initFilterChips();
    initSort();
    initVideoPreload();
    initGA4Events();
  });

  /* ── GA4 view_item_list / select_item ── */
  function initGA4Events() {
    if (typeof gtag !== 'function') return;
    var dataEl = document.getElementById('alatreyu-collection-items');
    var ctx = window.alatreyuCollectionContext || {};
    if (!dataEl) return;
    var items;
    try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(items) || items.length === 0) return;

    /* Fire once: list impression. Slice to GA4's 25-item cap on items[]. */
    gtag('event', 'view_item_list', {
      item_list_id: ctx.list_id || '',
      item_list_name: ctx.list_name || '',
      items: items.slice(0, 25)
    });

    /* Per-card click → select_item (delegated; captures Cmd+click + new-tab opens). */
    var carousel = document.getElementById('collection-carousel');
    if (!carousel) return;
    carousel.addEventListener('click', function (e) {
      var card = e.target.closest('.product-card');
      if (!card) return;
      var pos = parseInt(card.getAttribute('data-position') || '0', 10);
      var item = items[pos - 1];
      if (!item) return;
      gtag('event', 'select_item', {
        item_list_id: ctx.list_id || '',
        item_list_name: ctx.list_name || '',
        items: [item]
      });
    });
  }

  /* ── Auto-fit long product names to one line ── */
  function fitCardNames() {
    var names = document.querySelectorAll('.product-card__name');
    for (var i = 0; i < names.length; i++) {
      var el = names[i];
      el.style.fontSize = '';
      if (el.scrollWidth > el.clientWidth) {
        var scale = el.clientWidth / el.scrollWidth;
        var base = parseFloat(getComputedStyle(el).fontSize);
        el.style.fontSize = Math.floor(base * scale) + 'px';
      }
    }
  }

  /* ── Carousel ── */
  function initCarousel() {
    var track = document.getElementById('collection-carousel');
    var prevBtn = document.querySelector('.carousel-arrow--prev');
    var nextBtn = document.querySelector('.carousel-arrow--next');
    if (!track || !prevBtn || !nextBtn) return;

    /* Calculate one card step (width + gap) */
    function getCardStep() {
      var card = track.querySelector('.product-card:not(.filter-hidden)');
      if (!card) return 300;
      return card.offsetWidth + (parseInt(getComputedStyle(track).gap) || 24);
    }

    /* Start scrolled to the left edge */
    track.scrollLeft = 0;

    requestAnimationFrame(function () {
      fitCardNames();
      updatePeekCards();
    });

    /* Mark cards that are partially visible (peek cards) */
    function updatePeekCards() {
      var cards = track.querySelectorAll('.product-card:not(.filter-hidden)');
      var trackRect = track.getBoundingClientRect();
      var threshold = 0.85;

      for (var m = 0; m < cards.length; m++) {
        var card = cards[m];
        var cardRect = card.getBoundingClientRect();
        var visibleLeft = Math.max(cardRect.left, trackRect.left);
        var visibleRight = Math.min(cardRect.right, trackRect.right);
        var visibleWidth = Math.max(0, visibleRight - visibleLeft);
        var ratio = visibleWidth / cardRect.width;

        if (ratio > 0 && ratio < threshold) {
          card.classList.add('is-peek');
        } else {
          card.classList.remove('is-peek');
        }
      }
    }

    /* Arrow navigation */
    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getCardStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getCardStep(), behavior: 'smooth' });
    });

    /* Update peek cards on scroll */
    track.addEventListener('scroll', function () {
      updatePeekCards();
    }, { passive: true });

    /* Recalculate on resize */
    window.addEventListener('resize', function () {
      requestAnimationFrame(function () {
        fitCardNames();
        updatePeekCards();
      });
    });
  }

  /* ── Filter Dropdown (multi-select) ── */
  function initFilterChips() {
    var toggle = document.getElementById('filter-dropdown-toggle');
    var dropdown = document.getElementById('filter-dropdown');
    var clearBtn = document.getElementById('filter-clear-all');
    if (!toggle || !dropdown) return;

    var checkboxes = dropdown.querySelectorAll('.filter-checkbox');

    /* Toggle dropdown open/close */
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = dropdown.classList.contains('open');
      dropdown.classList.toggle('open');
      toggle.setAttribute('aria-expanded', !isOpen);
    });

    /* Close dropdown when clicking outside */
    document.addEventListener('click', function (e) {
      if (!dropdown.contains(e.target) && e.target !== toggle) {
        dropdown.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    /* Checkbox change → filter cards */
    for (var i = 0; i < checkboxes.length; i++) {
      checkboxes[i].addEventListener('change', function () {
        applyFilters(checkboxes, toggle);
      });
    }

    /* Clear all button */
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        for (var i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = false;
        }
        applyFilters(checkboxes, toggle);
      });
    }
  }

  function applyFilters(checkboxes, toggle) {
    var selected = [];
    var labels = [];
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        selected.push(checkboxes[i].value);
        labels.push(checkboxes[i].getAttribute('data-label'));
      }
    }

    /* Update toggle label */
    if (selected.length === 0) {
      toggle.firstChild.textContent = 'All ';
    } else {
      toggle.firstChild.textContent = '(' + selected.length + ') ';
    }

    /* Filter cards — OR logic (show card if it matches ANY selected tag) */
    var track = document.getElementById('collection-carousel');
    var cards = track.querySelectorAll('.product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (selected.length === 0) {
        card.classList.remove('filter-hidden');
      } else {
        var cardTags = (card.getAttribute('data-tags') || '').split(',');
        var match = false;
        for (var j = 0; j < selected.length; j++) {
          for (var k = 0; k < cardTags.length; k++) {
            if (cardTags[k].trim() === selected[j]) { match = true; break; }
          }
          if (match) break;
        }
        if (match) {
          card.classList.remove('filter-hidden');
        } else {
          card.classList.add('filter-hidden');
        }
      }
    }
    /* Reset scroll to start after filtering */
    track.scrollTo({ left: 0, behavior: 'smooth' });
  }

  /* ── Sort Buttons (client-side reorder with fade) ── */
  function initSort() {
    var btns = document.querySelectorAll('.sort-btn[data-sort]');
    var track = document.getElementById('collection-carousel');
    if (!btns.length || !track) return;

    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        if (this.classList.contains('sort-btn--active')) return;

        for (var j = 0; j < btns.length; j++) {
          btns[j].classList.remove('sort-btn--active');
        }
        this.classList.add('sort-btn--active');

        var sortValue = this.getAttribute('data-sort');

        /* Update URL without page reload */
        var url = new URL(window.location.href);
        if (sortValue === 'manual') {
          url.searchParams.delete('sort_by');
        } else {
          url.searchParams.set('sort_by', sortValue);
        }
        history.pushState({ sort: sortValue }, '', url.toString());

        sortCarousel(track, sortValue);
      });
    }

    /* Handle browser back/forward */
    window.addEventListener('popstate', function () {
      var params = new URLSearchParams(window.location.search);
      var sortValue = params.get('sort_by') || 'manual';
      for (var j = 0; j < btns.length; j++) {
        btns[j].classList.remove('sort-btn--active');
        if (btns[j].getAttribute('data-sort') === sortValue) {
          btns[j].classList.add('sort-btn--active');
        }
      }
      sortCarousel(track, sortValue);
    });
  }

  function sortCarousel(track, sortValue) {
    /* Fade out */
    track.classList.add('is-fading');

    setTimeout(function () {
      /* Collect cards */
      var cards = track.querySelectorAll('.product-card');
      var arr = [];
      for (var i = 0; i < cards.length; i++) {
        arr.push(cards[i]);
      }

      /* Sort */
      if (sortValue === 'created-descending') {
        arr.sort(function (a, b) {
          return parseInt(b.getAttribute('data-created') || '0') -
                 parseInt(a.getAttribute('data-created') || '0');
        });
      } else {
        arr.sort(function (a, b) {
          return parseInt(a.getAttribute('data-position') || '0') -
                 parseInt(b.getAttribute('data-position') || '0');
        });
      }

      /* Re-append in sorted order */
      for (var i = 0; i < arr.length; i++) {
        track.appendChild(arr[i]);
      }

      /* Reset scroll to start */
      track.scrollLeft = 0;

      /* Fade back in */
      setTimeout(function () {
        track.classList.remove('is-fading');
        fitCardNames();
      }, 50);
    }, 300);
  }

  /* ── Video Preloading ── */
  function initVideoPreload() {
    var cards = document.querySelectorAll('.product-card[data-video-url]');
    if (!cards.length) return;

    var preloaded = {};

    function preloadVideo(url) {
      if (preloaded[url]) return;
      preloaded[url] = true;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'video';
      link.href = url;
      document.head.appendChild(link);
    }

    /* Preload videos for visible cards immediately */
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          var url = entries[i].target.getAttribute('data-video-url');
          if (url) preloadVideo(url);
          observer.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: '200px' });

    for (var i = 0; i < cards.length; i++) {
      observer.observe(cards[i]);

      /* Also preload on hover for off-screen cards */
      cards[i].addEventListener('mouseenter', function () {
        var url = this.getAttribute('data-video-url');
        if (url) preloadVideo(url);
      });
    }
  }
})();
